<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Submissions" subtitle="Review event submissions and schedule them into rooms." :readonly="$authorised('con/schedule/access', 'read')">

	</app-content-head>

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />
		
		<app-content-filters-select v-model="filter.status" :allowDeselect="true" text="Status" tooltip="Filter by status" :options="$_.sortBy($util.options($constants.schedule.suggestions.statusFilter), 'text')" />
		
		<app-content-filters-select v-model="filter.room" :allow-deselect="true" text="Room" tooltip="Filter by room" :options="$util.options(references.rooms)" />
		
		<app-content-filters-date v-model="filter.from" tooltip="Filter from date" text="From" :max="filter.to" />
		
		<app-content-filters-date v-model="filter.to" tooltip="Filter to date" text="To" :min="filter.from" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no submission found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column />

				<app-table-column text="Name" />

				<app-table-column text="Room" />

				<app-table-column text="User" />

				<app-table-column text="Submitted on" />

			</app-table-head>

			<app-table-body>

				<app-table-row v-on:click="onEditClick(item.id)" :danger="item.cancelled" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-label :text="$constants.schedule.suggestions.statusName[item.status]" :type="$constants.schedule.suggestions.statusTheme[item.status]"  :subtext="item.reference" />
					<app-table-cell-text :text="item.name" />
					<app-table-cell-text v-if="item.room" :text="item.room.name" />
					<app-table-cell-text v-if="!item.room" text="-" />
					<app-table-cell-item v-if="item.application && !item.badge" :item="item.application" :show-icon="true" type="convention/registration/application" />
					<app-table-cell-item v-if="item.badge" type="convention/badge" :item="item.badge" :show-icon="true" />
					<app-table-cell-text :text="item.date.created | localDate('MM/DD/YYYY h:mma')" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			references: {
				rooms: [],
				days: []
			},
			filterSort: [
				{ value: 'created', text: 'Submitted' },
				{ value: 'name', text: 'Event name' }
			],
			filter: {
				from: 0,
				to: 0,
				status: 0,
				sort: 'created'
			},
			endpoint: 'convention/schedule/suggestions',
			live: 'convention/schedule/suggestions'
		}

	},

	computed: {

		layout: function() {

			return '120px auto 200px 200px 200px' 

		}

	}

}

</script>

<style scoped>

</style>